/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_HomeInputs */

const he_home_category_home = /** @type {(inputs: Home_Category_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לבית ולמטבח`)
};

const en_home_category_home = /** @type {(inputs: Home_Category_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home & Kitchen`)
};

/**
* | output |
* | --- |
* | "Home & Kitchen" |
*
* @param {Home_Category_HomeInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_home = /** @type {((inputs?: Home_Category_HomeInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_HomeInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_home(inputs)
	return en_home_category_home(inputs)
});